import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageSEO } from '@/components/SEO';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-muted/30" data-testid="not-found">
      <PageSEO title="Siden finnes ikke" description="Siden du leter etter ble ikke funnet." />
      <div className="text-center max-w-md">
        <p className="font-manrope text-6xl font-bold text-primary/20 mb-4">404</p>
        <h1 className="font-syne font-bold text-2xl md:text-3xl text-primary mb-4">
          Siden finnes ikke
        </h1>
        <p className="font-manrope text-muted-foreground mb-8">
          Adressen du skrev inn ble ikke funnet. Siden kan være flyttet eller slettet.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-syne font-bold text-sm uppercase tracking-wide px-8 py-4 bg-primary text-primary-foreground hover:bg-accent transition-colors duration-300"
        >
          <ArrowLeft className="w-4 h-4" />
          Tilbake til forsiden
        </Link>
      </div>
    </div>
  );
}
